module.exports = __webpack_public_path__ + "img/Dots.3fa3c69c.svg";